import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Package } from "lucide-react";
import { Button } from "@/components/ui/button";

const GiftTracking = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDF8F4] via-white to-[#F4F1EA]">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#F4F1EA] sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 text-[#6D6F7C] hover:text-[#3D405B]">
            <ArrowLeft className="w-5 h-5" />
            <span>Back</span>
          </Link>
          <h1 className="text-lg font-semibold text-[#3D405B]" style={{ fontFamily: 'Fraunces, serif' }}>
            Gift Tracking
          </h1>
          <div className="w-16" />
        </div>
      </header>

      {/* Coming Soon Content */}
      <main className="max-w-md mx-auto px-4 py-16 text-center">
        <div className="w-20 h-20 bg-[#F4F1EA] rounded-full flex items-center justify-center mx-auto mb-6">
          <Package className="w-10 h-10 text-[#6D6F7C]" />
        </div>

        <h2 
          className="text-2xl font-bold text-[#3D405B] mb-3"
          style={{ fontFamily: 'Fraunces, serif' }}
        >
          No gifts to track yet
        </h2>

        <p className="text-[#6D6F7C] mb-8">
          When you send gifts, you&apos;ll be able to track them here.
        </p>

        <Link to="/gifts">
          <Button className="bg-[#E07A5F] hover:bg-[#D0694E] text-white rounded-full">
            Visit Gift Shop
          </Button>
        </Link>
      </main>
    </div>
  );
};

export default GiftTracking;
